import { requestGet } from '@/common/request';

export interface DataOfList {
  totalPage: number;
  pageSize: number;
  currentPage: number;
  totalCount: number;
  list: {
    fileName: string;
    downloadUrl: string;
    successCount: number;
    failCount: number;
    status: number;
    longTaskId: string;
    fullProgress: number;
    currProgress: number;
    msg: number;
  }[];
}

// 活动盘品-获取促销选品配置信息
export default async function fileUploadList(query: {
  groupCode: string;
  currentPage?: number;
  pageSize?: number;
}): Promise<RequestResult> {
  return await requestGet('/goodsGroup/fileUploadList', query);
}
